import React from 'react';
import { AvatarComponent } from '../../../../../helpers/generateAvatarRamdomColor';

const getSalary = (payRate: any) => {
  if (!payRate || Object.keys(payRate).length === 0) {
    return '--';
  }
  return `$${Number(payRate.payRate || 0).toFixed(2)} /${payRate.paymentFrequency === 'hourly' ? 'hr' : 'year'}`;
};

const formatHours = (hours: number | null | undefined) => {
  if (hours === null || hours === undefined) {
    return '--';
  }
  return hours.toFixed(2);
};

const columns = () => {
  return [
    {
      name: 'Name',
      grow: 2,
      route: (row: any) => `/users/${row.user.id}/profile`,
      label: (row: any) => (
        <div className="d-flex align-items-center">
          <AvatarComponent
            name={`${row.user.firstName || '-'} ${row.user.lastName || '-'}`}
            size="35"
            userPicture={row.user.picture || ''}
          />
          <span className="ml-2">{`${row.user.firstName || '-'} ${row.user.lastName || '-'}`}</span>
        </div>
      ),
    },
    {
      name: 'Hours Worked',
      selector: (row: any) => row.workedHours || 0,
      grow: 1,
      cell: (row: any) => formatHours(row.workedHours),
    },
    {
      name: 'Overtime',
      selector: (row: any) => row.overtimeHours || 0,
      grow: 1,
      cell: (row: any) => formatHours(row.overtimeHours),
    },
    {
      name: 'PTO/Holiday',
      selector: (row: any) => row.ptoHours || 0,
      grow: 1,
      cell: (row: any) => formatHours(row.ptoHours),
    },
    {
      name: 'Training',
      selector: (row: any) => row.trainingHours || 0,
      grow: 1,
      cell: (row: any) => formatHours(row.trainingHours),
    },
    {
      name: 'Total Hours',
      selector: (row: any) => row.totalWorkedHours,
      grow: 1,
      cell: (row: any) => {
        return formatHours(row.totalWorkedHours);
      },
    },
    {
      name: 'Salary/Rate',
      selector: () => '$1.00 /hr',
      grow: 1,
      cell: (row: any) => getSalary(row.currentPayRate),
    },
  ];
};

export default columns;
